import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ISelectOption } from 'src/app/interfaces/select.interfaces';

@Component({
    selector: 'chip-list',
    templateUrl: 'chip-list.component.html',
    styleUrls: ['./chip-list.component.scss'],
    standalone: false
})
export class ChipListComponent implements OnInit {
    @Input() public options?: ISelectOption[];
    @Input() public label?: string;
    @Input() public required = false;
    @Input() public value: ISelectOption[] = [];
    @Input('multi-select') public multi_select = false;

    @Output() public onSelectionChange = new EventEmitter<ISelectOption[]>();

    public constructor() {}

    public ngOnInit() {}

    public onSelectionChangeHendler(e: ISelectOption) {
        if (!this.multi_select && this.options) {
            for (let i = 0; i < this.options.length; i++) {
                if (this.options[i].value === e.value) {
                    this.options[i].selected = e.selected;
                    this.onSelectionChange.emit([this.options[i]]);
                }
            }
        } else {
            const opt = this.options?.find((opt) => opt.value === e.value);
            if (opt) opt.selected = e.selected;

            this.onSelectionChange.emit(
                this.options?.filter((opt) => opt.selected),
            );
        }
    }
}
